import { CatalogBaseModel } from './CatalogBaseModel';

export class CatalogEvidenceSubmission extends CatalogBaseModel {
  static get entity() {
    return 'catalog-evidence-submissions';
  }

  static fields() {
    return {
      id: this.uid(),
    };
  }

  static apiConfig = {
    actions: {
      /**
       * Verify an evidence submission using AI
       *
       * Calls POST /evidence-submissions/ai-verify
       *
       * @param {Object} data
       * @param {number} data.learning_unit_id - Learning unit ID (must exist)
       * @param {number} data.user_id - User ID (must be attached to the learning unit)
       * @param {number} data.post_id - Post ID of the evidence submission
       * @param {string} data.comment - Draft comment
       * @param {string} data.criteria - Criteria for verification
       * @returns {Promise<Object>} { success, message, data } on success
       */
      async aiVerify(data) {
        return this.post('/v1/evidence-submissions/ai-verify', data, { save: false });
      }
    }
  };
}

export default CatalogEvidenceSubmission;
